<ng-container *ngIf="permConfig.isViewAllowed">
  <div class="container-fluid">
    <app-page-title title="List Supplementary Invoice"></app-page-title>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="d-flex justify-content-end">
                <div ngbDropdown class="d-inline-block dropdown">
                  <button type="button" class="btn btn-success btn-square btn-sm" ngbDropdownToggle>
                    Select Action<i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                  </button>
                  <div ngbDropdownMenu>
                    <a class="dropdown-item" routerLink="add"><i
                        class="mdi mdi-plus font-size-16 align-middle me-2"></i>Generate Invoice</a>
                    <span class="dropdown-item" [ngClass]="{'disabled-link': areSelected, 'enabled-link': !areSelected}"
                      (click)="generateIRN()">
                      <i class="mdi mdi-lightning-bolt-outline font-size-16 align-middle me-2"></i>Generate IRN</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 grid-container">
                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                  [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                  [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true"
                  [enableCellTextSelection]="true" (gridReady)="onGridReady($event)" [gridOptions]="gridOptions"
                  (rowSelected)="onRowSelected($event)">
                </ag-grid-angular>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
  <app-forbidden></app-forbidden>
</ng-container>